export default __webpack_public_path__ + "static/media/proluxLogoTransparent.d478973d.png";